class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.pendingPricingRunId = 0;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
   // console.log("triggeredBy::",triggeredBy)
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (typeof window.cartValidate === 'function') {
      window.cartValidate();
    }
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    },10);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.querySelector('#CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(this.querySelector('.drawer__inner-empty'), focusElement);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const pricingToken = this.beginPendingPricing(parsedState);
    const pricingRunId = pricingToken ? ++this.pendingPricingRunId : this.pendingPricingRunId;

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;
      if (section.id === 'cart-drawer') {
        const newDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newCount = newDoc.querySelectorAll('.cart-item').length;
        const currentCount = document.querySelectorAll('#CartDrawer .cart-item').length;
        if (newCount < currentCount) return;
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      window.cartPendingPricing?.apply();
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    },10);
    this.waitForPendingPricingAndRefresh(pricingToken, pricingRunId);
  }

renderContentsBulk(parsedState) {
  const pricingToken = this.beginPendingPricing(parsedState);
  const pricingRunId = pricingToken ? ++this.pendingPricingRunId : this.pendingPricingRunId;
  // Don't use outerHTML replacement - it breaks event listeners!
  // Instead, update innerHTML of existing elements
  
  const sections = this.getSectionsToRender();
  
  sections.forEach((section) => {
    const sectionHtml = parsedState.sections?.[section.id];
    
    if (!sectionHtml) {
      console.warn(`No HTML found for section: ${section.id}`);
      return;
    }
    
    const sectionElement = section.selector 
      ? document.querySelector(section.selector) 
      : document.getElementById(section.id);
    
    if (!sectionElement) {
      console.warn(`Section element not found: ${section.selector || section.id}`);
      return;
    }
    
    // Use innerHTML instead of outerHTML to preserve the container
    const newContent = this.getSectionInnerHTML(sectionHtml, section.selector);
    sectionElement.innerHTML = newContent;
    window.cartPendingPricing?.apply();
  });
  
  // Re-bind event listeners after content update
  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.open();
  }, 0);
  this.waitForPendingPricingAndRefresh(pricingToken, pricingRunId);
}



  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
//   getSectionInnerHTML(html, selector) {
//   const doc = new DOMParser().parseFromString(html, 'text/html');
//   const el = selector ? doc.querySelector(selector) : doc.body.firstElementChild;
//   return el?.innerHTML || ''; // fallback
// }


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  beginPendingPricing(parsedState) {
    if (!parsedState) return null;
    if (typeof parsedState.item_count !== 'undefined' && Number(parsedState.item_count || 0) === 0) return null;
    const variantId = parsedState.variant_id || parsedState.id;
    return window.cartPendingPricing?.begin({ variantId, scope: 'all' });
  }

  async waitForPendingPricingAndRefresh(pricingToken, pricingRunId) {
    if (!pricingToken) return;

    try {
      const cartItems = document.querySelector('cart-drawer-items');
      if (cartItems?.waitForDiscountApplied) {
        await cartItems.waitForDiscountApplied();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 1500));
      }
      if (pricingRunId !== this.pendingPricingRunId) return;

      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) return;
      if (pricingRunId !== this.pendingPricingRunId) return;

      const responseText = await response.text();
      if (pricingRunId !== this.pendingPricingRunId) return;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

      const replaceFromDoc = (doc) => {
        selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = doc.querySelector(selector);
          if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
        });
        window.cartPendingPricing?.apply();
      };

      replaceFromDoc(html);

      await new Promise((resolve) => setTimeout(resolve, 380));
      if (pricingRunId !== this.pendingPricingRunId) return;

      const response2 = await fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, { cache: 'no-store' });
      if (!response2.ok) return;
      if (pricingRunId !== this.pendingPricingRunId) return;
      const responseText2 = await response2.text();
      if (pricingRunId !== this.pendingPricingRunId) return;
      const html2 = new DOMParser().parseFromString(responseText2, 'text/html');
      replaceFromDoc(html2);
    } catch (error) {
      console.error(error);
    } finally {
      window.cartPendingPricing?.end(pricingToken);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
